import { Helmet } from "react-helmet-async";
import { constants } from "../../../constants/constants";
import { useLocation } from "react-router-dom";

const CustomHeaderTitle = ({ title }) => {
  const location = useLocation();

  // Replace placeholders with actual values
  const replaceVars = (str) =>
    str
      ?.replaceAll("{REACT_APP_MEDIAURL}", constants.MEDIAURL)
      ?.replaceAll("{REACT_APP_API_BASE_URL}", constants.BASE_URL);

  const data = [
    replaceVars(process.env.REACT_APP_CSP_DEFAULT_SRC),
    replaceVars(process.env.REACT_APP_CSP_SCRIPT_SRC),
    replaceVars(process.env.REACT_APP_CSP_STYLE_SRC),
    replaceVars(process.env.REACT_APP_CSP_IMG_SRC),
    replaceVars(process.env.REACT_APP_CSP_MEDIA_SRC),
    replaceVars(process.env.REACT_APP_CSP_FRAME_SRC),
    replaceVars(process.env.REACT_APP_CSP_CONNECT_SRC),
  ].filter(Boolean).join(" ");

  return (
    <Helmet>
      <title>Star Dream Cruises | {title || ""}</title>
      <meta httpEquiv="Content-Security-Policy" content={data} />
    </Helmet>
  );
};

export default CustomHeaderTitle;

//OLD CODE:
// import { Helmet } from "react-helmet-async";
// import { constants } from "../../../constants/constants";
// import { useEffect } from "react";
// import { Navigate, useLocation, useNavigate } from "react-router-dom";
// const CustomHeaderTitle = ({ title }) => {

//   let data = `default-src ${constants.MEDIAURL} ${constants.BASE_URL} https://cms.stardreamcruises.rwccruisesuat.com/ https://stardreamcruises.com/ https://cms.b2cdev.rwcruisesuat.com/ http://localhost:3000 http://localhost:8000 https://media.rwcfleet.com https://www.google.com https://cdn.jsdelivr.net https://cdnjs.cloudflare.com 'unsafe-inline';
// script-src *;
// style-src 'self' 'unsafe-inline' https://example.com https://code.ionicframework.com https://fonts.googleapis.com https://cdn.jsdelivr.net;
// img-src 'self' blob: data: https: http://localhost:8000 https://media.rwcfleet.com;
// media-src 'self' ${constants.MEDIAURL} http://localhost:8000 https://media.rwcfleet.com https://media.rwcfleet.com/media https: blob: data:;
// frame-src 'self' ${constants.MEDIAURL} ${constants.MEDIAURL}/media https://media.rwcfleet.com https://media.rwcfleet.com/media http://localhost:8000 blob:;
// connect-src 'self' ${constants.MEDIAURL} ${constants.BASE_URL} 'unsafe-inline' https://cdn.jsdelivr.net https://cdnjs.cloudflare.com http://localhost:8000 https://media.rwcfleet.com;`;

// let location = useLocation();

//   return (
//     <Helmet>
//       <title>Star dream Cruises | {title||""}</title>

//       <meta http-equiv="Content-Security-Policy" content={data}/>

//     </Helmet>
//   );
// };

// export default CustomHeaderTitle;
